/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable promise/catch-or-return */
import { createRef, Component } from 'react';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlert } from 'foundations-components/transitional/components/FloatingAlert';
import { EditorPage } from 'foundations-components/transitional/components/EditorPage';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { isMigrationFailed } from 'knowledge-content-types/KnowledgeBaseV3Service/MigrationTypes';
import { ErrorTypes } from '../../constants/edit/ArticleValidationConstants';
import { CATEGORIZE_STEP, WRITE_STEP } from '../../constants/edit/StepsConstants';
import { LINKS_COLOR_SETTING_KEY_PATH } from 'knowledge-content-ui/constants/TemplateEditorConstants';
import PublishingOverlay from '../../components/edit/PublishingOverlay';
import EditorTinyMCE from '../../components/edit/write/EditorTinyMCE';
import EditHeader from '../../components/edit/EditHeader';
import EditSubHeader from '../../components/edit/EditSubHeader';
import WebFontLoaderContainer from 'knowledge-content-ui/containers/WebFontLoaderContainer';
import { hasNoSelectedListsError, hasNoSelectedAccessGroupsError } from '../../utils/articleVisibilityUtils';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { makeAsyncComponent } from '../../utils/asyncUtils';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getArticlesStatePath } from '../../routing/utils/internalPaths';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadableCategorizeForm = Loadable({
  delay: 300,
  loader: () => import( /* webpackChunkName: "EditCategorizeForm" */'../../components/edit/categorize/CategorizeForm').then(m => m.default),
  LoadingComponent: ({
    pastDelay
  }) => pastDelay ? /*#__PURE__*/_jsx(LoadingSpinner, {}) : null
});
const AsyncContentAssistantIntroHighlightContainer = makeAsyncComponent(() => import( /* webpackChunkName: "ContentAssistantIntroHighlightContainer" */'knowledge-content-ui/containers/ContentAssistantIntroHighlightContainer'));
class EditPageTinyMCE extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      showAlteredArticleAlert: true
    };
    this.focusEditor = () => {
      // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'tinyMCE'.
      if (tinyMCE.activeEditor.initialized === true) {
        // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'tinyMCE'.
        tinyMCE.activeEditor.fire('focus');
        // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'tinyMCE'.
        tinyMCE.activeEditor.selection.select(
        // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'tinyMCE'.
        tinyMCE.activeEditor.getBody(), true);
        // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'tinyMCE'.
        tinyMCE.activeEditor.selection.collapse(false);
      } else {
        // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'tinyMCE'.
        tinyMCE.activeEditor.once('init', this.focusEditor);
      }
    };
    this.handleErrorFocus = ({
      error,
      step
    }) => {
      const {
        onStepChange
      } = this.props;
      onStepChange(step);

      // The focus() methods needs to be called on the next tick
      // otherwise it won't work for UISelects
      // this setTimeout works much like underscore's defer
      setTimeout(() => {
        switch (error) {
          case ErrorTypes.TITLE_ERROR:
            {
              this._titleInputRef.current.focus();
              break;
            }
          case ErrorTypes.BODY_ERROR:
            {
              this.focusEditor();
              break;
            }
          case ErrorTypes.SLUG_ERROR:
            {
              var _this$_urlInputRef$cu;
              (_this$_urlInputRef$cu = this._urlInputRef.current) === null || _this$_urlInputRef$cu === void 0 || _this$_urlInputRef$cu.focus();
              break;
            }
          case ErrorTypes.ARTICLE_LANGUAGE_NOT_SUPPORTED_BY_KNOWLEDGE_BASE:
            {
              this._languageSelectRef.current.focus();
              break;
            }
          case ErrorTypes.CATEGORY_ERROR:
            {
              this._categorySelectRef.current.focus();
              break;
            }
          case ErrorTypes.NO_LIST_SELECTED_ERROR:
            {
              this._visibilitySelectRef.current.focus();
              break;
            }
          case ErrorTypes.NO_ACCESS_GROUP_SELECTED_ERROR:
            {
              this._visibilitySelectRef.current.focus();
              break;
            }
          case ErrorTypes.ARTICLE_IS_PUBLIC_IN_PRIVATE_KNOWLEDGE_BASE:
            {
              this._visibilitySelectRef.current.focus();
              break;
            }
          default:
        }
      }, 0);
    };
    this._languageSelectRef = /*#__PURE__*/createRef();
    this._categorySelectRef = /*#__PURE__*/createRef();
    this._titleInputRef = /*#__PURE__*/createRef();
    this._visibilitySelectRef = /*#__PURE__*/createRef();
    this._urlInputRef = /*#__PURE__*/createRef();
    this.handleAlteredArticleAlertClose = () => this.setState({
      showAlteredArticleAlert: false
    });
    this.handlePublishArticle = () => {
      const {
        onCustomSlugEndingSave,
        onPrePublishArticle,
        onPublishArticle
      } = this.props;
      const prePublishSteps = [onCustomSlugEndingSave()];
      onPrePublishArticle();
      Promise.all(prePublishSteps).then(onPublishArticle);
    };
  }
  renderHeader(noSelectedListError, noSelectedAccessGroupError) {
    const {
      article,
      articleSaveStatus,
      customSlugEnding,
      hasBufferedChanges,
      hasLocalChanges,
      isDomainNotConnectedError,
      isPublishArticleTemporarilyDisabled,
      knowledgeScopes,
      onAddToGroup,
      onRemoveFromGroup,
      onRouteChange,
      readOnly,
      selectedStep,
      selectedCategoryId,
      templateSettings
    } = this.props;
    const linksColor = templateSettings.getIn(LINKS_COLOR_SETTING_KEY_PATH).color;
    return (
      /*#__PURE__*/
      // @ts-expect-error ts-migrate(2741) FIXME: Property 'multiLangCategories' is missing in type ... Remove this comment to see the full error message
      _jsx(EditHeader, {
        article: article,
        articleSaveStatus: articleSaveStatus,
        customSlugEnding: customSlugEnding,
        disablePublish: readOnly,
        hasBufferedChanges: hasBufferedChanges,
        hasLocalChanges: hasLocalChanges,
        isDomainNotConnectedError: isDomainNotConnectedError,
        isPublishArticleTemporarilyDisabled: isPublishArticleTemporarilyDisabled,
        linksColor: linksColor,
        noSelectedListError: noSelectedListError,
        noSelectedAccessGroupError: noSelectedAccessGroupError,
        knowledgeScopes: knowledgeScopes,
        onAddToGroup: onAddToGroup,
        onErrorFocus: this.handleErrorFocus,
        onPublishArticle: this.handlePublishArticle,
        onRemoveFromGroup: onRemoveFromGroup,
        onRouteChange: onRouteChange,
        subscreen: selectedStep,
        selectedCategoryId: selectedCategoryId,
        templateSettings: templateSettings
      })
    );
  }
  renderSubHeader(noSelectedListError, noSelectedAccessGroupError) {
    const {
      article,
      customSlugEnding,
      onStepChange,
      selectedCategoryId,
      selectedStep
    } = this.props;
    return /*#__PURE__*/_jsx(EditSubHeader, {
      article: article,
      customSlugEnding: customSlugEnding,
      noSelectedListError: noSelectedListError,
      noSelectedAccessGroupError: noSelectedAccessGroupError,
      onStepChange: onStepChange,
      selectedCategoryId: selectedCategoryId,
      selectedStep: selectedStep
    });
  }
  renderReadOnlyAccessAlert() {
    const {
      knowledgeScopes: {
        canWriteArticle
      }
    } = this.props;
    if (canWriteArticle) {
      return null;
    }
    const langKey = 'knowledgeContentUI.shared.notification.error';
    return /*#__PURE__*/_jsx(View, {
      position: "fixed",
      pointerEvents: "none",
      textAlign: "center",
      inlineSize: "100%",
      zIndex: "1211",
      children: /*#__PURE__*/_jsx(FloatingAlert, {
        closeable: false,
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${langKey}.title.readOnlyAccess`
        }),
        type: "info",
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${langKey}.message.readOnlyArticleAccess`
        })
      })
    });
  }
  readOnlyLegacyAlert() {
    const {
      migrationReport,
      onRouteChange
    } = this.props;
    if (!migrationReport || isMigrationFailed(migrationReport.status)) {
      return null;
    }
    return /*#__PURE__*/_jsx(View, {
      position: "fixed",
      pointerEvents: "none",
      textAlign: "center",
      inlineSize: "100%",
      zIndex: "1211",
      children: /*#__PURE__*/_jsx(FloatingAlert, {
        closeable: false,
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.shared.notification.error.title.readOnlyAccess"
        }),
        type: "info",
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "knowledgeContentUI.shared.notification.error.message.readOnlyLegacyAlert_jsx",
          elements: {
            UILink: Link
          },
          options: {
            onClick: () => onRouteChange(getArticlesStatePath(migrationReport.structuredContentPlatformKnowledgeBaseId))
          }
        })
      })
    });
  }
  renderAlteredArticleAlert() {
    const {
      importedArticleNeedsReview
    } = this.props;
    const {
      showAlteredArticleAlert
    } = this.state;
    if (!importedArticleNeedsReview.needsReview || !showAlteredArticleAlert) {
      return null;
    }
    const langKey = 'knowledgeContentUI.importArticles.alteredArticleNotification';
    return /*#__PURE__*/_jsx(View, {
      position: "fixed",
      pointerEvents: "none",
      textAlign: "center",
      inlineSize: "100%",
      zIndex: "1211",
      children: /*#__PURE__*/_jsx(FloatingAlert, {
        closeable: true,
        onClose: this.handleAlteredArticleAlertClose,
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${langKey}.title`
        }),
        type: "warning",
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${langKey}.message`
        })
      })
    });
  }
  renderStep() {
    const {
      article,
      articleSubtitle,
      articleTitle,
      articleHtmlTitle,
      categoryOrganizationInfo,
      closeTranslateTemplateModal,
      customSlugEnding,
      headHtml,
      isUngatedForSeoKbTitle,
      knowledgeBase,
      knowledgeScopes,
      listsDetail,
      metaDescription,
      multiLangCategories,
      openTranslateTemplateModal,
      onAddToGroup,
      onArticleSubtitleChange,
      onArticleTitleBlur,
      onArticleTitleChange,
      onArticleHtmlTitleSave,
      onArticleHtmlTitleChange,
      onCategoryChange,
      onCategoryTranslationSuccess,
      onCreateMultiLangCategory,
      onCustomSlugEndingSave,
      onCustomSlugEndingUpdate,
      onHeadHtmlChange,
      onHeadHtmlSave,
      onLanguageChange,
      onMetaDescriptionChange,
      onMetaDescriptionSave,
      onRemoveFromGroup,
      onSelectedListsChange,
      onSelectedListsClose,
      onTagsChange,
      onVisibilityChange,
      readOnly,
      selectedCategory,
      selectedLists,
      selectedListsHaveChanged,
      selectedSubcategory,
      selectedStep,
      selectedVisibility,
      templateSettings,
      translateTemplateModal,
      onKnowledgeBaseChange,
      articleBufferError
    } = this.props;
    const linksColor = templateSettings.getIn(LINKS_COLOR_SETTING_KEY_PATH).color;
    switch (selectedStep) {
      case CATEGORIZE_STEP:
        return /*#__PURE__*/_jsx(LoadableCategorizeForm, {
          article: article,
          articleHtmlTitle: articleHtmlTitle,
          onArticleHtmlTitleSave: onArticleHtmlTitleSave,
          onArticleHtmlTitleChange: onArticleHtmlTitleChange,
          categoryOrganizationInfo: categoryOrganizationInfo,
          categorySelectRef: this._categorySelectRef,
          languageSelectRef: this._languageSelectRef,
          closeTranslateTemplateModal: closeTranslateTemplateModal,
          customSlugEnding: customSlugEnding,
          headHtml: headHtml,
          isUngatedForSeoKbTitle: isUngatedForSeoKbTitle,
          knowledgeBase: knowledgeBase,
          knowledgeScopes: knowledgeScopes,
          listsDetail: listsDetail,
          multiLangCategories: multiLangCategories,
          metaDescription: metaDescription,
          onMetaDescriptionSave: onMetaDescriptionSave,
          onMetaDescriptionChange: onMetaDescriptionChange,
          openTranslateTemplateModal: openTranslateTemplateModal,
          onAddToGroup: onAddToGroup,
          onCategoryChange: onCategoryChange,
          onCreateMultiLangCategory: onCreateMultiLangCategory,
          onCustomSlugEndingSave: onCustomSlugEndingSave,
          onCustomSlugEndingUpdate: onCustomSlugEndingUpdate,
          onHeadHtmlChange: onHeadHtmlChange,
          onHeadHtmlSave: onHeadHtmlSave,
          onLanguageChange: onLanguageChange,
          onCategoryTranslationSuccess: onCategoryTranslationSuccess,
          onRemoveFromGroup: onRemoveFromGroup,
          onSelectedListsChange: onSelectedListsChange,
          onSelectedListsClose: onSelectedListsClose,
          onTagsChange: onTagsChange,
          onVisibilityChange: onVisibilityChange,
          readOnly: readOnly,
          selectedCategory: selectedCategory,
          selectedLists: selectedLists,
          selectedListsHaveChanged: selectedListsHaveChanged,
          selectedSubcategory: selectedSubcategory,
          selectedVisibility: selectedVisibility,
          translateTemplateModal: translateTemplateModal,
          urlInputRef: this._urlInputRef,
          visibilitySelectRef: this._visibilitySelectRef,
          onKnowledgeBaseChange: onKnowledgeBaseChange,
          articleBufferError: articleBufferError
        });
      case WRITE_STEP:
      default:
        {
          return /*#__PURE__*/_jsx(NavMarker, {
            name: "ARTICLE_EDITOR_LOAD",
            children: /*#__PURE__*/_jsx(EditorTinyMCE, {
              article: article,
              articleSubtitle: articleSubtitle,
              articleTitle: articleTitle,
              canWriteArticle: knowledgeScopes.canWriteArticle,
              linksColor: linksColor,
              onArticleSubtitleChange: onArticleSubtitleChange,
              onArticleTitleBlur: onArticleTitleBlur,
              onArticleTitleChange: onArticleTitleChange,
              readOnly: readOnly,
              templateSettings: templateSettings,
              titleInputRef: this._titleInputRef
            })
          });
        }
    }
  }
  render() {
    const {
      selectedLists,
      selectedVisibility,
      showPublishingOverlay
    } = this.props;
    const noSelectedListError = hasNoSelectedListsError({
      selectedLists,
      selectedVisibility
    });
    const noSelectedAccessGroupError = hasNoSelectedAccessGroupsError({
      selectedLists,
      selectedVisibility
    });
    return /*#__PURE__*/_jsxs("div", {
      "data-test-id": "edit-page-editor",
      children: [/*#__PURE__*/_jsx(WebFontLoaderContainer, {}), showPublishingOverlay && /*#__PURE__*/_jsx(PublishingOverlay, {}), this.renderReadOnlyAccessAlert(), this.readOnlyLegacyAlert(), this.renderAlteredArticleAlert(), /*#__PURE__*/_jsx(EditorPage, {
        headerComponent: this.renderHeader(noSelectedListError, noSelectedAccessGroupError),
        mainSectionFlush: true,
        tabs: this.renderSubHeader(noSelectedListError, noSelectedAccessGroupError),
        children: this.renderStep()
      }), /*#__PURE__*/_jsx(AsyncContentAssistantIntroHighlightContainer, {})]
    });
  }
}
export default EditPageTinyMCE;